import React, { memo, useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { useAdminColors } from '@/hooks/admin/useAdminColors';
import type { CorkBoardTag } from '@/types/residents/corkBoard';

interface TagStatsStripProps {
  tags: CorkBoardTag[];
}

export const TagStatsStrip: React.FC<TagStatsStripProps> = memo(({ tags }) => {
  const { redesign } = useAdminColors();

  const { total, active, hidden } = useMemo(() => {
    const t = tags.length;
    const a = tags.filter((tag) => tag.isEnabled).length;
    return { total: t, active: a, hidden: t - a };
  }, [tags]);

  return (
    <View
      style={[
        styles.strip,
        {
          backgroundColor: redesign.glass.buttonBg,
          borderColor: redesign.card.border,
        },
      ]}
    >
      <Text style={[styles.text, { color: redesign.text.secondary }]}>
        <Text style={[styles.value, { color: redesign.text.primary }]}>{total}</Text>
        {' total · '}
        <Text style={[styles.value, { color: redesign.text.primary }]}>{active}</Text>
        {' active · '}
        <Text style={[styles.value, { color: redesign.text.primary }]}>{hidden}</Text>
        {' hidden'}
      </Text>
    </View>
  );
});

TagStatsStrip.displayName = 'TagStatsStrip';

const styles = StyleSheet.create({
  strip: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    borderWidth: 1,
    marginBottom: 12,
    alignItems: 'center',
  },
  text: {
    fontSize: 12,
  },
  value: {
    fontWeight: '600',
  },
});
